import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const images = pageImages['multi-materials-full-eject-closed-end-balers'];


function MultiMaterialsFullEjectClosedEndBalers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link className="active" to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Multi Materials Full-Eject Closed-End Balers</h2>
          
          <div className="page-summary-notes">
              <span>100 percent separation of each bale</span>
              <span>Full bale ejection after tying</span>
              <span>Strong fit for changing materials</span>
          </div>
          <PagePhotoViewer  images={images} leadText={"Multi Materials Full Eject Horizontals are available in several models and styles for baling different types of materials. Full Eject balers are useful to separate different types of baled materials when the baling press is used for more than one type of material with different baling properties, by tying and fully ejecting a completed bale before beginning a new bale. We can modify models of standard balers for use as full eject multi-material balers. Full Eject balers are required at times to make bales of materials standard eject balers cannot do, such as shredded slippery plastics and certain small piece foam rubbers. Let one of our representatives help you select your multi-material baling press, or our designers build a custom baler for you."} eyebrow="Equipment Photos" />
          
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default MultiMaterialsFullEjectClosedEndBalers;
